export enum EnrolmentBatchesEnums {
	ALL = 'all',
	ACTIVE = 'active',
	HISTORY = 'history',
	PSM = 'psm',
	ORGANISATION = 'organisation',
	PSM_AND_ORGANISATION = 'psmAndOrganisation',
	NO_VALID_WORK_ORDER = 'noValidWorkOrder'
}
